export default __webpack_public_path__ + "static/media/purple_dolphin_icon_against.05191f41.svg";